import { useQuery } from "@tanstack/react-query";
import { casesApi } from "@/api/cases";
import { AuditTrailView } from "../AuditTrailView";
interface Props {
  caseId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export default function CaseAuditTrailModal({
  caseId,
  open,
  onOpenChange,
}: Props) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["case-audit-trail", caseId],
    queryFn: () => casesApi.getAuditTrail(caseId),
    enabled: open && !!caseId,
  });
  return (
    <AuditTrailView
      key={caseId}
      open={open}
      onOpenChange={onOpenChange}
      title="Audit Trail del Caso"
      subtitle={data?.case_title}
      logs={data?.logs || []}
      loading={isLoading}
      error={!!error}
      onRetry={() => {
        void refetch();
      }}
    />
  );
}
